module.exports = __webpack_public_path__ + "static/button-action-do-e9f19a738d7b64aa1f3c12740dda488b.png";